const RETURN_POLICY_COLUMNS = {
  id: 'Id',
  label: 'Label',
  range: 'Availability range',
  restrictionCauseName: 'Restriction cause',
  restrictionCauseDescription: 'Restriction cause description',
  withdrawalPeriod: 'Withdrawal period',
  coveredBy: 'Return cost covered by',
  name: 'Name',
  street: 'Street',
  postCode: 'Postal code',
  city: 'City',
  countryCode: 'Country code',
  email: 'Email',
  phoneNumber: 'Phone number',
  cashOnDeliveryNotAllowed: 'Cash on delivery not allowed',
  freeAccessoriesReturnRequired: 'Free accessories return required',
  refundLoweredByReceivedDiscount: 'Refund lowered by received discount',
  businessReturnAllowed: 'Business return allowed',
  collectBySellerOnly: 'Collect by seller only',
} as const;

export default RETURN_POLICY_COLUMNS;
